module.exports = __webpack_public_path__ + "img/pageBg.f9f9dcd5.png";